import React from 'react';
import { Link } from 'gatsby';

// This component wraps Gatsby's Link component and preserves the app=true parameter
// if it's present in the current URL
const AppAwareLink = ({ to, children, ...props }) => {
  const isAppMode = typeof window !== 'undefined' && 
    (new URLSearchParams(window.location.search).get('app') === 'true');
  
  // Only add the app parameter if we're in app mode
  const linkTo = isAppMode && !to.includes('?app=true') 
    ? `${to}${to.includes('?') ? '&' : '?'}app=true` 
    : to;
  
  return (
    <Link to={linkTo} {...props}>
      {children}
    </Link>
  );
};

export default AppAwareLink; 